import { DateTime } from 'luxon';
import { weekDayMonthDay } from '../../../constants/dateStrings';
// TODO: Replace Luxon's DateTime.local().toLocaleString(DateTime.DATE_HUGE) with Day.js equivalent
// const formattedDate = dayjs().format('MMMM D, YYYY');
export var FILLER = '----'; // confirm this with UX, could be N/A too.
export var formatCityState = function (address) {
    if (address) {
        var city = address.city, state = address.state;
        return city && state ? "".concat(city, ", ").concat(state.toUpperCase()) : '----';
    }
    return '----';
};
export var formatDateTime = function (date, startTime, endTime, dateFormatStr, timeFormatStr) {
    if (dateFormatStr === void 0) { dateFormatStr = weekDayMonthDay; }
    if (timeFormatStr === void 0) { timeFormatStr = 'h a'; }
    if (!date || !startTime || !endTime)
        return '';
    var start = dateFormat(startTime, timeFormatStr);
    var end = dateFormat(endTime, timeFormatStr);
    return "".concat(dateFormat(date, dateFormatStr), ", ").concat(start, " - ").concat(end);
};
export var dateFormat = function (date, format, localTimezone) {
    if (date === undefined || date === null || date === '')
        return '';
    var dateTime = DateTime.fromISO(date, { zone: 'utc' });
    if (localTimezone) {
        var localZone = DateTime.local().zoneName;
        dateTime = dateTime.setZone(localZone);
    }
    return dateTime
        .toFormat(format)
        .replace('Tue', 'Tues')
        .replace('Thu', 'Thurs');
};
export var timeFormat = function (time) {
    return time[0] === '0' ? time.slice(1) : time;
};
export var formatAMPM = function (time) {
    var regExAM = new RegExp(' am', 'ig');
    var regExPM = new RegExp(' pm', 'ig');
    var replaceValueAM = ' a.m.';
    var replaceValuePM = ' p.m.';
    return time.replace(regExAM, replaceValueAM).replace(regExPM, replaceValuePM);
};
export var renderOrderTotal = function (orderDetailsData) {
    var _a;
    var hasReturnedItemStatus = false;
    var _b = orderDetailsData.grandTotalAmount, grandTotalAmount = _b === void 0 ? 0 : _b, _c = orderDetailsData.returnTotal, returnTotal = _c === void 0 ? 0 : _c, _d = orderDetailsData.statusDescription, statusDescription = _d === void 0 ? '' : _d;
    if (statusDescription !== 'Returned') {
        (_a = orderDetailsData.fulfillmentGroups) === null || _a === void 0 ? void 0 : _a.forEach(function (group) {
            var _a;
            (_a = group === null || group === void 0 ? void 0 : group.returnShipments) === null || _a === void 0 ? void 0 : _a.forEach(function (item) {
                if (item.returnStatus === 'Return Completed') {
                    hasReturnedItemStatus = true;
                }
            });
        });
    }
    return grandTotalAmount === null || grandTotalAmount === void 0 ? void 0 : grandTotalAmount.toLocaleString('en-US', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    });
};
